import { render, staticRenderFns } from "./jobList.vue?vue&type=template&id=895ceac8&scoped=true"
import script from "./jobList.vue?vue&type=script&lang=js"
export * from "./jobList.vue?vue&type=script&lang=js"
import style0 from "./jobList.vue?vue&type=style&index=0&id=895ceac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895ceac8",
  null
  
)

export default component.exports